/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 */
import { Component } from 'react'
import { Container } from 'flux/utils'
import { withRouter } from 'react-router'
import NProgress from 'nprogress'
import LocalDate from '../../../domain/type/Date'
import SessionAction from '../../../action/session'
import HotelOptionsStore from '../../../store/options/HotelOptionsStore'
import ReportCheckInSearchStore from '../../../store/check_in/ReportCheckInSearchStore'
import ReportCheckInsStore from '../../../store/check_in/ReportCheckInsStore'
import ShowReportCheckInView from '../../../view/pages/report/check_in/ShowReportView'
import ReportCheckInAction from '../../../action/monthly_report/check_in'
import MonthlyReportAction from '../../../action/monthly_report'

class ShowReportContainer extends Component {
  static getStores() {
    return [HotelOptionsStore, ReportCheckInSearchStore, ReportCheckInsStore]
  }

  static calculateState(prevState, props) {
    return {
      option_hotels: HotelOptionsStore.getState(),
      search: ReportCheckInSearchStore.getState(),
      check_ins: ReportCheckInsStore.getState(),
      ...props
    }
  }

  async componentDidMount() {
    NProgress.start()

    await SessionAction.fetchUserHotels()

    const date = this.state.match.params.date
    const target_date = date ? LocalDate.parse(date) : LocalDate.today().beginningOfMonth()
    const hotel_id = this.state.match.params.hotel_id

    if (this.state.search.search_hotel_id) {
      ReportCheckInAction.requestSearch(this.state.search, target_date)
    }

    NProgress.done()
  }

  render() {
    return ShowReportCheckInView(this.state)
  }
}

export default withRouter(Container.create(ShowReportContainer, { withProps: true }))
